<template>
  <section :class="['automation-section', { 'blur-background': isBlurred }]">
    <header>
      <el-row>
        <el-col :md="3" :lg="5">
          <el-button type="text" @click="goBack" class="back-button">
            Back
          </el-button>
        </el-col>
      </el-row>
    </header>
    <el-row justify="center">
      <el-col :xs="24" :sm="20" :md="16" :lg="12">
        <el-card shadow="hover" class="automation-card">
          <div class="form-header">
            <div class="icon" style="font-size: 59px; color: #2196f3">
              <img
                src="@/assets/ConnectorAutomation.svg"
                alt="ai"
                style="width: 79px; margin-right: 30px"
              />
            </div>
            <h4>Describe Your Automation Flow</h4>
            <p style="font-family: 'Segoe UI', sans-serif">
              Tell us what you want to automate in a sentence or two
            </p>
          </div>
          <el-radio-group
            v-model="creationType"
            size="mini"
            class="custom-radio-group"
          >
          </el-radio-group>
          <el-input
            type="textarea"
            rows="4"
            placeholder="EX: When a new invoice is created in Kodefast, if the amount is over $300, create it in QuickBooks and send a Slack notification."
            v-model="formText"
          ></el-input>
          <el-button
            type="primary"
            size="large"
            round
            :loading="loading"
            class="submit-button"
            @click="generateAutomation"
          >
            🚀 AI Create Your Automation
          </el-button>
        </el-card>
      </el-col>
    </el-row>
    <transition name="fade">
      <div v-if="loading" class="loading-overlay">
        <div class="loading-content">
          <i class="el-icon-loading loading-spinner"></i>
          <p class="loading-text">AI Create Your Automation, please wait…</p>
        </div>
      </div>
    </transition>
  </section>
</template>

<script>
import { mapActions } from "vuex";
export default {
  data() {
    return {
      creationType: "Prompt",
      formText: "",
      loading: false,
      isBlurred: false,
    };
  },
  methods: {
    ...mapActions("globalApis", ["createAutomationFlowwithAI"]),

    goBack() {
      this.isBlurred = true;
      this.$confirm("Are you sure to Exit?", "Warning", {
        confirmButtonText: "Yes",
        cancelButtonText: "No",
        type: "warning",
      })
        .then(() => {
          this.isBlurred = false;
          this.$router.replace({ path: `/connector/all-workflows` });
        })
        .catch(() => {
          this.isBlurred = false;
          this.$message({ message: "Exit canceled", type: "warning" });
        });
    },

    async generateAutomation() {
      if (!this.formText.trim()) {
        this.$message.warning("Please describe your automation flow.");
        return;
      }
      this.loading = true;
      try {
        const params = {
          user_query: this.formText,
          isDependable: false,
          isActivated: true,
        };
        const result = await this.createAutomationFlowwithAI(params);
        if (result?.success) {
          this.$notify({
            title: "Success",
            message: result.message || "Automation created successfully!",
            type: "success",
            duration: 3000,
          });
          this.$router.push({
            path: `/connector/workflow/${result.data._id}`,
          });
        } else {
          this.$message.warning("Something went wrong.");
        }
      } catch (error) {
        this.$message.error("Failed to create automation.");
      } finally {
        this.loading = false;
      }
    },
  },
};
</script>

<style scoped>
.automation-section {
  padding: 20px;
}

.back-button {
  margin-left: 5%;
  background-color: #6b52ae !important;
  color: white !important;
  width: 59px;
}

.automation-card {
  padding: 30px;
  border-radius: 12px;
  margin-top: 30px;
  /* border: 1px solid #2196f3; */
}

.form-header {
  text-align: center;
  margin-bottom: 20px;
}

.form-header h4 {
  margin: 10px 0 5px;
  font-weight: 600;
  color: #121018;
}

.form-header p {
  color: #666;
  font-size: 14px;
}

.custom-radio-group {
  margin-bottom: 20px;
  display: flex;
  justify-content: center;
}

.submit-button {
  background-color: #6b52ae;
  border-color: #6b52ae;
  color: #fff;
  width: 100%;
  margin-top: 20px;
  border-radius: 8px;
}

/* Custom Loading Overlay */
.loading-overlay {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  backdrop-filter: blur(5px);
  background-color: rgba(0, 0, 0, 0.3);
  z-index: 9999;
  display: flex;
  align-items: center;
  justify-content: center;
}

.loading-content {
  text-align: center;
}

.loading-spinner {
  font-size: 48px;
  color: #00bfff; 
  animation: spin 1s linear infinite;
  margin-bottom: 10px;
}

.loading-text {
  color: #000000;
  font-size: 18px;
  font-weight: 500;
}
.blur-background {
  filter: blur(7px);
  pointer-events: none;
  user-select: none;
  transition: all 0.3s ease-in-out;
}

@keyframes spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
